import { render, staticRenderFns } from "./FormRecords.vue?vue&type=template&id=fb8e30cc"
import script from "./FormRecords.vue?vue&type=script&lang=js"
export * from "./FormRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports